var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-block cell-block-suspended-row",style:(_vm.cellStyle)},[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipConfig),expression:"tooltipConfig"}],class:['cell-tooltip', 'cell-suspended-row']})])
}
var staticRenderFns = []

export { render, staticRenderFns }